import api from '@app/utils/api';
import qs from 'qs';

export const fetchUnits = (params) => {
  return api.get(`/owner/calc-engine/units?${qs.stringify(params)}`);
};

export const fetchCategories = (params) => {
  return api.get(`/owner/calc-engine/categories?${qs.stringify(params)}`);
};

export const fetchCategorySources = (categoryId, params) => {
  return api.get(
    `/owner/calc-engine/categories/${categoryId}/sources?${qs.stringify(
      params
    )}`
  );
};

export const createCategory = (body) => {
  return api.post('/owner/calc-engine/categories', body);
};

export const updateCategory = (categoryId, body) => {
  return api.put(`/owner/calc-engine/categories/${categoryId}`, body);
};

export const removeCategory = (categoryId) => {
  return api.delete(`/owner/calc-engine/categories/${categoryId}`);
};

export const createUnit = (body) => {
  return api.post('/owner/calc-engine/units', body);
};

export const updateUnit = (unitId, body) => {
  return api.put(`/owner/calc-engine/units/${unitId}`, body);
};

export const removeUnit = (unitId) => {
  return api.delete(`/owner/calc-engine/units/${unitId}`);
};

export const createCategorySource = (categoryId, body) => {
  return api.post(`/owner/calc-engine/categories/${categoryId}/sources`, body);
};

export const updateCategorySource = (categoryId, sourceId, body) => {
  return api.put(
    `/owner/calc-engine/categories/${categoryId}/sources/${sourceId}`,
    body
  );
};

export const removeCategorySource = (categoryId, sourceId) => {
  return api.delete(
    `/owner/calc-engine/categories/${categoryId}/sources/${sourceId}`
  );
};

export const fetchInputTableFields = (sourceId, params) => {
  return api.get(
    `/owner/calc-engine/${sourceId}/input-table-fields?${qs.stringify(params)}`
  );
};

export const createInputTableField = (sourceId, body) => {
  return api.post(`/owner/calc-engine/${sourceId}/input-table-fields`, body);
};

export const updateInputTableField = (sourceId, fieldId, body) => {
  return api.put(
    `/owner/calc-engine/${sourceId}/input-table-fields/${fieldId}`,
    body
  );
};

export const removeInputTableField = (sourceId, fieldId) => {
  return api.delete(
    `/owner/calc-engine/${sourceId}/input-table-fields/${fieldId}`
  );
};

export const fetchInputTableData = (sourceId, params) => {
  return api.get(
    `/owner/calc-engine/${sourceId}/input-table-data?${qs.stringify(params)}`
  );
};

export const createInputTableData = (sourceId, body) => {
  return api.post(`/owner/calc-engine/${sourceId}/input-table-data`, body);
};

export const updateInputTableData = (sourceId, dataId, body) => {
  return api.put(
    `/owner/calc-engine/${sourceId}/input-table-data/${dataId}`,
    body
  );
};

export const removeInputTableData = (sourceId, dataId) => {
  return api.delete(
    `/owner/calc-engine/${sourceId}/input-table-data/${dataId}`
  );
};

export const fetchCategorySource = (categoryId, sourceId, params) => {
  return api.get(
    `/owner/calc-engine/categories/${categoryId}/sources/${sourceId}?${qs.stringify(
      params
    )}`
  );
};
